import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class StageFiveService {
  static getStageFive (id) {
    return axios.get(`${url}/admin/stage-five/fetch/${id}`)
  }
}

export default StageFiveService
